import React, {useEffect} from "react";
import {useParams} from "react-router-dom";
import {Controller, useForm} from "react-hook-form";
import {
    Box,
    Button,
    TextField,
    Typography
} from "@material-ui/core";
import {makeStyles} from "@material-ui/core/styles";
import apiHelper from "../../../util/ApiHelper";
import {toast} from "react-toastify";
import {
    ToggleButton,
    ToggleButtonGroup
} from "@material-ui/lab";

const useStylesAll = makeStyles((theme) => ({
    root: {
        margin: 0,
        marginBottom: 20,
        minWidth: "100%",
    },
    last: {
        margin: 0,
    },
    input: {
        width: "100%",
        maxWidth: "380px",
        marginTop: 20,
        marginBottom: 20,
        "& button": {
            fontSize: "13px",
            lineHeight: "15px",
            width: "25%",
        },
    },
}));

const defaultFormValues = {
    localizations: {
        en: {
            name: ''
        },
        tc: {
            name: ''
        },
    },
    status: true
}

export default function FilmTagForm({disabled, ...props}) {
    const {history, fetchData, seq, setSeq} = props;
    const classes = useStylesAll();
    let {id} = useParams();

    const {
        control,
        handleSubmit,
        reset
    } = useForm({defaultValues: defaultFormValues});

    const getFilmTag = React.useCallback(async () => {
        if (id) {
            apiHelper.hkiff
                .getFilmTagById(id)
                .then((response) => {
                    console.log(response.data);
                    reset(response.data);
                })
                .catch(function (error) {
                    console.log(error);
                });
        }
    }, [id])

    useEffect(() => {
        getFilmTag();
    }, [getFilmTag]);

    const updateTag = async (data) => {
        try {
            const result = await apiHelper.hkiff.updateFilmTagById(
                id,
                data
            );
            if (result.data.id !== undefined) {
                console.log(result.data);
                toast.dark("Your changes is saved.");
                getFilmTag();
            }
        } catch (err) {
            console.log(err);
        }
    };

    const createTag = async (data) => {
        try {
            const result = await apiHelper.hkiff.postFilmTag(
                {...data, sequence: seq ? seq : 0}
            );
            console.log(result);
            if (result.data.id !== undefined) {
                console.log('res', result);
                toast.dark("Tag created.");
                reset(defaultFormValues);
                fetchData();
                setSeq && setSeq(seq + 1);
            }
        } catch (err) {
            console.log(err);
        }
    };

    const onSubmit = (data) => {
        const sendTag = () => {
            if (id) {
                updateTag(data);
            } else {
                createTag(data);
            }
        };
        sendTag();
    };

    return (
        <>
            <Box fontWeight={900} fontSize={13} mb={2}
                 width="100%">
                <Typography
                    variant="p">{props.description}</Typography>
            </Box>
            <form autoComplete="off"
                  onSubmit={handleSubmit(onSubmit)}>
                <fieldset disabled={disabled}
                          className="fieldset">
                    <Box width="100%">
                        <Controller
                            control={control}
                            name="localizations.en.name"
                            defaultValue=""
                            render={({field}) => {
                                return (
                                    <TextField
                                        id="outlined-basic"
                                        className={classes.root}
                                        label="Name (English)"
                                        variant="outlined"
                                        helperText="The name is how it appears on your site."
                                        {...field}
                                        fullWidth
                                        required
                                    />
                                );
                            }}
                        />
                        <Controller
                            control={control}
                            name="localizations.tc.name"
                            defaultValue=""
                            render={({field}) => {
                                return (
                                    <TextField
                                        id="outlined-basic"
                                        className={classes.root}
                                        label="Name (Traditional Chinese)"
                                        variant="outlined"
                                        helperText="The name is how it appears on your site."
                                        {...field}
                                        fullWidth
                                        required
                                    />
                                );
                            }}
                        />
                        <Controller
                            control={control}
                            name="status"
                            render={({
                                         field: {
                                             value,
                                             onChange,
                                             ...rest
                                         },
                                         fieldState: {error},
                                     }) => (
                                <ToggleButtonGroup
                                    {...rest}
                                    value={value}
                                    onChange={(event, newFormats) => {
                                        if (newFormats !== null) {
                                            onChange(newFormats);
                                        }
                                    }}
                                    exclusive
                                    aria-label="Status"
                                    className={classes.input}
                                >
                                    <ToggleButton
                                        value={true}
                                        aria-label="Active"
                                        style={{width: "50%"}}
                                        disabled={disabled}
                                    >
                                        Active
                                    </ToggleButton>
                                    <ToggleButton
                                        value={false}
                                        aria-label="Inactive"
                                        style={{width: "50%"}}
                                        disabled={disabled}
                                    >
                                        Inactive
                                    </ToggleButton>
                                </ToggleButtonGroup>
                            )}
                        />

                        <Box display="flex"
                             alignItems="flex-end"
                             alignContent="flex-end">
                            {disabled || (
                                <Box>
                                    <Button
                                        className={classes.last}
                                        variant="contained"
                                        color="primary"
                                        size="large"
                                        type="submit"
                                    >
                                        {props.submitBtnTxt}
                                    </Button>
                                </Box>
                            )}
                        </Box>
                    </Box>
                </fieldset>
            </form>
        </>
    );
}
